/**
 * Module-level store for the URL received from parent (pitaliy.js SET_URL message).
 * Used by axios request interceptor to set public-page header when on a public subdomain.
 */
let currentReceivedUrl = "";

/**
 * Sets the current page URL received from parent. Call this when handling SET_URL message.
 * @param url - Full URL string from parent
 */
export function setCurrentReceivedUrl(url: string): void {
  currentReceivedUrl = url ?? "";
}

/**
 * Returns the current received URL (for use in API interceptors).
 * @returns The URL string, or empty string if not set
 */
export function getCurrentReceivedUrl(): string {
  return currentReceivedUrl;
}
